export default __webpack_public_path__ + "9b4396c9c15950ff08f0d350b488f5a8.png";